import { faUsers } from "@fortawesome/pro-solid-svg-icons/faUsers";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconGroup: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faUsers} />;
};
